import { Row,Col, Button, Spinner } from "reactstrap";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import Layout from "../../layout/Layout";
import SideBar from "../../global/Components/SideBar/SideBar";
import styles from './CategoryPage.module.scss';
import Range from "../../components/Range/Range";
import { getRequest } from "../../global/utils/apiCall";
import Product from "../../global/Components/Items/Product/Product";
import PaginationComponent from "../../global/Components/Pagination/PaginationComponent";
import { useOnChangeHandler } from "../../global/utils/hooks/useOnChangeHandler";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import ProductStatus from "./featured/ProductStatus/ProductStatus";
import useWindowSize from "../../global/utils/hooks/useWindowSize";
import { Sidebar } from "primereact/sidebar";
import { useToggle } from "../../global/utils/hooks/useToggle";
import SEO from "../../global/Components/SEO/SEO";
import SortBy from "./featured/SortBy/SortBy";
import Discount from "./featured/Discount/Discount";
import CategoryFilters from "./featured/CategoryFilters/CategoryFilters";
import Resault from "./featured/Resault/Resault";
import { Toast } from 'primereact/toast';
import CustomBreadrumbs from "../../global/Components/Breadcrumb/CustomBreadrumbs";

const PRODUCTS_URL = 'api/v1/products';
const CATEGORIES_FILTERS_URL  = 'api/v1/categories/';

export default function Category() {
  const[searchParams, setSearchParams] = useSearchParams();
  const windowSize = useWindowSize();
  const toast = useRef(null);

  const search = useMemo(() => {
     return (
      searchParams.get('search') || ''
    )
  }
  , [searchParams]);

  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();  

  const searchQuery = new URLSearchParams(location.search).toString()

  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState();
  
  const [filters, setFilters, onChangeHandlerFilters] = useOnChangeHandler();

  const [isOffCanvas, setIsOffCanvas, toggleIsOffCanvas] = useToggle(false);

  const { id } = useParams();

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
    if(typeof(message) == 'string'){
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }
    else {
      toast.current.show(
        message.map((msg) => ({severity:'error', summary: 'Error', detail: msg, life: 5000}) )
      )
    }
  }

  const callCategoryProducts = async () => {
    setIsLoading(true);
    setIsOffCanvas(false);

    try {
      const response = await getRequest(`${PRODUCTS_URL}/?${searchQuery}`
        ,{
        params: {
          limit: 21, 
          category_id: id && id   
        }
      }
    );
      setProducts(response.data.data);
      setMetaData(response.data.meta);
      setIsLoading(false);
    } 
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {

        if(error.response.data.errors) {
          const errors = error?.response?.data?.errors;          
          let message = [];
          Object.keys(errors).forEach((field) => {
            message.push(`${field}: ${errors[field]}`);
          });
          showError(message);
        } else {
          showError(error?.response?.data?.message)
        }
      }
      setIsLoading(false);
    }
    finally{
      setIsLoading(false);
    }
  }

  const callCategoriesFilters = async () => {
    setIsLoading(true);

    try {
      const response = await getRequest(`${CATEGORIES_FILTERS_URL}${id}/filters`, {
        params: {
          id: id,
        }
      });
      setFilters(response.data.data);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
    finally {
      setIsLoading(false);
    }
  }

  const setPage = (pageNumber)=>{
    searchParams.set('page', pageNumber);
    setSearchParams(searchParams);
  }

  const handleClearAllFilters = () => {
    setSearchParams("");
  }

  useEffect(() => {
    callCategoryProducts();
    callCategoriesFilters();
  },[]);

  useEffect(() => {
    callCategoryProducts();
    callCategoriesFilters();
  },[id]);

  useEffect(() => {

    callCategoryProducts();

  },[searchParams]);

return (
    <category-component>
        <Layout>
          <SEO title={products.length > 0 ? `${products[0].category.title}` : ''} />
          <Toast ref={toast} position="top-center" />
        
            <div className="container-xxl">
                <Row className={`pt-5 pb-3`}>
                  {
                    windowSize.width < 1025
                      ? <>
                          {/* offanvas */}
                          <Sidebar visible={isOffCanvas} onHide={toggleIsOffCanvas}>
                            <Range  
                              onOffCanvas={setIsOffCanvas} />
                            {
                              isLoading 
                                ? (
                                  <div className="text-center">
                                    <Spinner color='primary' className='mx-auto'>
                                      Loading...
                                    </Spinner>
                                  </div>
                                ) 
                                : (
                                  <CategoryFilters filters={filters} onOffCanvas={setIsOffCanvas} />
                                )
                            }
                            <div className="text-center my-3">
                              <Button onClick={handleClearAllFilters}>
                                Clear Filters
                              </Button>
                            </div>
                          </Sidebar>
                        </>
                      : <SideBar xs={12} sm={12} md={3}>
                          <Range  
                            onOffCanvas={setIsOffCanvas} />
                            {
                              isLoading 
                                ? (
                                  <div className="text-center">
                                    <Spinner color='primary' className='mx-auto'>
                                      Loading...
                                    </Spinner>
                                  </div>
                                ) 
                                : (
                                  <CategoryFilters filters={filters} onOffCanvas={setIsOffCanvas} />
                                )
                            }
                          <div className="text-center my-3">
                            <Button onClick={handleClearAllFilters}>
                              Clear Filters
                            </Button>
                          </div>
                        </SideBar>
                  }
                  
                  <Col xs={12} sm={12} md={9} className={`${styles.productList}`} >
                    <div className={`bg-white p-4 min-vh-100 ${styles.lgtBackground}`}>
                      <Row>
                        <Col sm={12} md={8} className={`mb-3 border-bottom ${styles.divider} `}>
                          {
                            products.length > 0 &&
                              <CustomBreadrumbs id={id} title={products[0].category.title} />
                          }
                        </Col>
                        <Col sm={12} md={4} className={`mb-3 border-bottom ${styles.divider} d-none d-md-block`}>
                          <Resault metaData={metaData}/>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}className={`mb-3 ${styles.fsSmall} ${styles.showTablet}`}>
                          <Button
                            onClick={toggleIsOffCanvas}
                          >
                            <i className="bi bi-funnel me-2"></i>
                            Filters
                          </Button>
                        </Col>
                        <Col xs={6} className={`mb-3 ${styles.fsSmall} ${styles.showTablet} d-md-none`}>
                          <Resault metaData={metaData}/>
                        </Col>
                        <Col sm={12} md={12} xl={3} className={`mb-3 ${styles.fsSmall} ${styles.rightDivider}`}>
                          <ProductStatus />
                        </Col>
                        <Col sm={12} md={12} xl={6} className={`mb-1 ${styles.fsSmall}`}>
                          <SortBy />
                        </Col>
                        <Col sm={12} md={12} xl={3} className={`mb-3 ${styles.fsSmall}`}>
                          <Discount />
                        </Col>
                      </Row>
                      <Row>
                        { 
                          isLoading 
                          ? (
                              <div className="text-center py-4">
                                <Spinner color='primary' className='mx-auto'>
                                  Loading...
                                </Spinner>
                              </div>
                            ) 
                          : (
                              products.length > 0
                                ? (
                                  products.map((product, i) => (
                                    <Col key={product.id} xs={12} sm={6} md={4} xxl={3}>
                                      <Product key={i} data={product} />
                                    </Col>
                                  ))
                                ) 
                                : (
                                  <p className="fw-bold py-4">No Products to display</p>
                                )  
                            )
                        }
                      </Row>
                      <Row>
                        <Col sm={12}>
                          {
                            metaData &&
                              metaData.last_page > 1 
                                ? (
                                  <PaginationComponent currentPage={searchParams.get('page') || 1} setCurrentPage={setPage}  metaData={metaData}/>
                                ) 
                                : ('')
                          }                          
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
            </div>
        </Layout>
    </category-component>
  )
}
